import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faCircle } from '@fortawesome/free-solid-svg-icons'

export default function DashletSuccessIcon() {
  return (
    <span className="icon is-medium has-text-success ml-1">
      <span
        style={{ pointerEvents: 'auto' }}
        className={`lox-no-border lox-tooltip-moveable has-tooltip-arrow has-tooltip-right has-tooltip-primary has-text-weight-normal`}
        data-tooltip={"Yes or True"}
      >
        <span className="fa-stack fa-sm">
          <FontAwesomeIcon icon={faCircle} className="fa-stack-1x" />
          <FontAwesomeIcon icon={faCheck} className="fa-stack-1x has-text-white" />
        </span>
      </span>
    </span>
  )
}
